import {Async, isLoaded} from 'Core/models/Async';
import {RetreivedPlan} from 'Quoting/models/DTOs/QuoteForm';
import {CoverageApplicability} from 'Quoting/models/enum';
import {flatten} from 'fp-ts/lib/Array';
import {pipe} from 'fp-ts/lib/pipeable';

export const findCoverage = (plansWithCoverages: Async<RetreivedPlan[]>, coverageCd: string, planCd: string) =>
  isLoaded(plansWithCoverages)
    ? pipe(
        plansWithCoverages.Data,
        plans => plans.filter(p => p.planCode === planCd),
        plans => plans.map(p => p.coverages),
        flatten,
        coverages => coverages.find(cov => cov.code === coverageCd)
      )
    : undefined;

export const findMandatoryCoverageCd = (plansWithCoverages: Async<RetreivedPlan[]>, planCd: string) =>
  isLoaded(plansWithCoverages)
    ? pipe(
        plansWithCoverages.Data,
        plans => plans.filter(p => p.planCode === planCd),
        plans => plans.map(p => p.coverages),
        flatten,
        coverages => coverages.find(cov => cov.applicability === CoverageApplicability.Mandatory),
        coverage => coverage?.code
      )
    : undefined;
